import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AgentApi, type GenerateJobRequest } from '@/domains/agent/apis';
import { HomeMaterialApi } from '@/domains/home/apis/home-material-api';
import { ref } from 'vue';
import { useTracking } from '../tracking/use-tracking';

export const useFindSolutions = () => {
  const homeMaterialApiService = injectService<HomeMaterialApi>(HomeMaterialApi);
  const agentApiService = injectService<AgentApi>(AgentApi);
  const { sendTracking } = useTracking();

  const findSolutionsAgentId = ref(0);
  const jobId = ref('');

  const getAgentId = async () => {
    if (!findSolutionsAgentId.value) {
      const oldProducts = await homeMaterialApiService.getProducts();
      findSolutionsAgentId.value =
        oldProducts.find((p) => p.function_id === 'find_solution_material_v2')?.agent_id || 0;
    }

    return findSolutionsAgentId.value;
  };

  async function createChatJob(input: string) {
    sendTracking('mse_find_solutions_submit_input', 'agent_home', { input });

    if (!jobId.value) {
      const payload: GenerateJobRequest = {
        input,
        agent_ids: [findSolutionsAgentId.value],
        team_ids: [],
      };

      jobId.value = (await agentApiService.chatJob(payload)).job_id;

      sendTracking('ss_mse_find_solution', 'create_task')
    }

    window.location.href = `/ai/agent-flow/${jobId.value}`;
  }

  async function useExampleExtras(input: string) {
    sendTracking('mse_find_solutions_click_example', 'agent_home', { input });
  }

  async function submitPipeline(input: string) {
    await getAgentId();
    await createChatJob(input);
  }

  return {
    useExampleExtras,
    submitPipeline,
  };
};
